import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class ValidationProcessService {
  constructor(private http: HttpClientService) {}

  public getEventsLog(id: string | number): Observable<any> {
    return this.http
      .get("/api/validation_processes/" + id + "/events_log")
      .pipe(tap((_) => console.log("ValidationProcessService.getEventsLog: Ok.")));
  }

  public postStart(id: string, channel: string = null): Observable<any> {
    const params = {
      channel: channel,
    };
    return this.http
      .post("/api/validation_processes/" + id + "/start", params)
      .pipe(tap((_) => console.log("ValidationProcessService.postStart: Ok.")));
  }

  public getCurrentStep(id: string): Observable<any> {
    return this.http
      .get("/api/validation_processes/" + id + "/current_step")
      .pipe(tap((_) => console.log("ValidationProcessService.getCurrentStep: Ok.")));
  }

  public getAllValidationProcess(page, items): Observable<any> {
    const options = {
      params: {
        page: page,
        items: items,
      },
    };
    return this.http
      .get("/api/validation_processes", options)
      .pipe(tap((_) => console.log("ValidationProcessService.getAllValidationProcess: Ok.")));
  }

  public postIne(id, options): Observable<any> {
    return this.http
      .post("/api/validation_processes/" + id + "/veridoc/ine", options)
      .pipe(tap((_) => console.log("ValidationProcessService.postIne: Ok.")));
  }

  public postCurp(id, options): Observable<any> {
    return this.http
      .post("/api/validation_processes/" + id + "/veridoc/curp", options)
      .pipe(tap((_) => console.log("ValidationProcessService.postCurp: Ok.")));
  }

  public getInternalUser(person_id): Observable<any> {
    return this.http
      .get("/api/persons/" + person_id + "/internal_user")
      .pipe(tap((_) => console.log("ValidationProcessService.getInternalUser: Ok.")));
  }

  public postVeridoc(params, id): Observable<any> {
    return this.http
      .post("/api/validation_processes/" + id + "/veridoc", params)
      .pipe(tap((_) => console.log("ValidationProcessService.postVeridoc: Ok.")));
  }

  public postValidationProcessEvent(id, event, metadata = {}): Observable<any> {
    const params = {
      metadata: metadata,
    };
    return this.http
      .post("/api/validation_processes/" + id + "/event?event_name=" + event, params)
      .pipe(tap((_) => console.log("ValidationProcessService.postValidationProcessEvent: Ok.")));
  }

  public createReferences(id, references): Observable<any> {
    return this.http
      .post("/api/validation_processes/" + id + "/references", references)
      .pipe(tap((_) => console.log("ValidationProcessService.createReferences: Ok.")));
  }

  public postResendLink(id, targets): Observable<any> {
    return this.http
      .post("/api/validation_processes/" + id + "/resend_link", targets)
      .pipe(tap((_) => console.log("ValidationProcessService.postResendLink: Ok.")));
  }

  public getApplicationByProcessValidationId(id): Observable<any> {
    return this.http
      .get("/api/validation_processes/" + id, {})
      .pipe(tap((_) => console.log("ValidationProcessService.getApplicationByProcessValidationId: Ok.")));
  }

  public postRemindEvent(id: string, metadata): Observable<any> {
    const params = {
      ...metadata,
    };
    return this.http
      .post("/api/validation_processes/" + id + "/remind_event", params)
      .pipe(tap((_) => console.log("ValidationProcessService.postRemindEvent: Ok.")));
  }
}
